import { Component, OnInit } from '@angular/core';

import { AuthorizationService, MagnetService, NotificationsSettingsService, ToastService } from '@mirage-projects/cw-commons';

@Component({
    selector: 'cw-notification-panel',
    templateUrl: './notification-panel.component.html',
    standalone: false,
})
export class NotificationPanelComponent implements OnInit {
    settings: any = {};
    constructor(
        private notificationSettingsService: NotificationsSettingsService,
        private toastService: ToastService,
        private authorizationService: AuthorizationService,
        private magnetService: MagnetService
    ) {}

    ngOnInit(): void {
        this.initSettings();
    }

    initSettings(): void {
        this.settings.localSettings = this.notificationSettingsService.getAllNotificationPreferences();

        // Default value
        this.settings.email = {
            JOB_FINISHED: true,
            QUOTA_EXCEEDED: true,
        };
        if (this.magnetService.isConnectingFromMagnet()) {
            this.notificationSettingsService
                .getEmailPreferences()
                .subscribe((reponse) => (this.settings.email = reponse.emailNotifications));
        }
    }

    save(): void {
        this.notificationSettingsService.setAllNotificationPreferences(this.settings.localSettings);
        this.toastService.generic('NOTIFICATION_PANEL.SAVED');
    }

    changeCategories(value: boolean): void {
        this.settings.localSettings.categories.CATALOG_OBJECT_UPDATE = value;
        this.settings.localSettings.categories.CATALOG_VISIBILITY_REVOKED = value;
        this.save();
    }

    saveEmailPreferences(): void {
        this.notificationSettingsService.setEmailPreferences(this.settings.email).subscribe(
            () => {
                this.toastService.generic('NOTIFICATION_PANEL.SAVED');
            },
            () => {
                this.toastService.error('NOTIFICATION_PANEL.ERROR_SAVING_EMAIL_PREFERENCES');
                this.initSettings();
            }
        );
    }

    isUserLoggedAdmin(): boolean {
        return this.authorizationService.isUserLoggedAdmin();
    }
}
